module.exports = __webpack_public_path__ + "static/img/login_bannerimg.7b82814.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_bannerimg.png
// module id = 7lCI
// module chunks = 52